<template>
  <CModal
    :title="title"
    :color="color"
    :show.sync="showModal"
    size="lg"
  >
    <CForm id="import_form" method="POST" enctype="multipart/form-data">
      <CRow>
        <CCol md="12">
          <CInput
            label="Archivo a importar:"
            :lazy="false"
            :value.sync="$v.form.import_file.$model"
            type="file"
            name="import_file"
            id="import_file"
          />
        </CCol>
      </CRow>
    </CForm>
    <template #footer>
        <CButton @click="closeModal" color="secondary">Cancelar</CButton>
        <CButton @click="submitForm" :color="color">Aceptar</CButton>
    </template>
  </CModal>
</template>

<script>
import { validationMixin } from 'vuelidate'

export default {
  name: 'PropertiesImportModal',
  mixins: [validationMixin],
  data () {
    return {
      showModal: false,
      title: 'Importar Propiedades',
      color: 'info',
      form: {
        import_file: null
      }
    }
  },
  validations: {
    form: {
      import_file: {
        // puedes agregar validaciones si quieres
      }
    }
  },
  methods: {
    openModal () {
      this.showModal = true
      this.$v.$reset()
      this.form.import_file = null
    },
    closeModal () {
      this.showModal = false
      this.$v.$reset()
      this.form.import_file = null
    },
    submitForm () {
      this.$v.$touch()
      if (this.$v.$invalid) return

      const formData = new FormData()
      formData.append('import_file', this.form.import_file)

      this.$emit('import', formData)
      this.closeModal()
    }
  }
}
</script>

<style>
.input_code .form-control {
  text-align: center;
}
</style>
